import axios from "axios";

const validatePhoneNumber = async (mobile) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_URL}/api/auth/verify-mobile`,
      { mobile },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      }
    );

    return (
      response.data.status === true &&
      response.data.data?.isMobileValid === true
    );
  } catch (error) {
    console.error("Phone validation error:", error);
    return false;
  }
};

export default validatePhoneNumber;
